import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import './mgs-delivery-modal-style.scss';

import { useSnackbar } from '@src/providers/SnackbarProvider';

import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

const MGSDeliveryModal = ({ open, onClose, onConfirm }) => {
  const { showSnackbar } = useSnackbar();
  const [isChecked, setIsChecked] = useState(false);

  const handleConfirm = () => {
    if (isChecked) {
      onConfirm();
    } else {
      showSnackbar({ message: 'Please check the box to proceed your order.' });
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div id="mgs-delivery-modal-wrapper">
        <Typography cName="modal-title" variant="subtitle1" component="p" style={{ color: '#F44336' }}>
          Important Information
        </Typography>

        <FormControlLabel
          className="confirm-check"
          control={
            <Checkbox
              className="confirm-checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
          }
          label={
            <div>
              <Typography variant="body3" component="p" style={{ color: '#090A0FDE' }}>
                By checking this box, I understand that MGS product will be dispatched from Korea.
              </Typography>
              <Typography variant="body3" component="p" style={{ color: '#F44336' }}>
                Delivery may take longer than usual.
              </Typography>
            </div>
          }
        />

        <Button cName="checkout-btn" size="medium" variant="contained" onClick={handleConfirm}>
          Checkout
        </Button>
      </div>
    </Modal>
  );
};

export default MGSDeliveryModal;
